module.exports = __webpack_public_path__ + "static/img/9.c9c893c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/2/sp/9.png
// module id = zMu5
// module chunks = 0